import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {Button} from 'ui-library';

import i18n from 'i18n';
import API from '../../lib/api';

import {logoPayoneerImg} from 'assets/images';
import {getCheckSwiftUrl} from 'config/app';
import { getDefaultTitle } from 'config/app';

const companyName = getDefaultTitle()

const PayoneerForm = createClass({
  propTypes: {
    currentUser: PropTypes.object
  },

  payoneerRegister() {
    const {currentUser} = this.props;

    API.getPayoneerUrl({
      _id: currentUser._id,
      callbackURL: `${window.location.origin}/settings/money`
    }, (err, res) => {
      if (err || res.code) return console.error(err, res);
      window.location.href = res.redirect;
    });
  },

  getContent() {
    const {currentUser} = this.props;
    const {payoneerStatus} = currentUser;
    const messagesPayoneer = this.getMessages();
    if (payoneerStatus) {
      const message = messagesPayoneer[payoneerStatus] || {};
      return (
        <div>
          <p className='text-justify'>{message.l1}</p>
          <p className='text-justify margin-top-1x'>{message.l2}</p>
        </div>
      );
    }
    return this.renderPayoneerForm();
  },

  getMessages() {
    return {
      pending: {
        es: i18n.get('PAYONNER_STATUS_MESSAGES_PENDING_LABEL'),
        l1: i18n.get('PAYONNER_STATUS_MESSAGES_PAYONNER_DESCRIPTION',{companyName}),
        l2: i18n.get('PAYONNER_STATUS_MESSAGES_PENDING_TEXT')
      },
      declined: {
        es: i18n.get('PAYONNER_STATUS_MESSAGES_DECLINED_LABEL'),
        l1: i18n.get('PAYONNER_STATUS_MESSAGES_PAYONNER_DESCRIPTION',{companyName}),
        l2: i18n.get('PAYONNER_STATUS_MESSAGES_DECLINED_TEXT',{companyName})
      },
      approved: {
        es: i18n.get('PAYONNER_STATUS_MESSAGES_APPROVED_LABEL'),
        l1: i18n.get('PAYONNER_STATUS_MESSAGES_PAYONNER_DESCRIPTION',{companyName}),
        l2: i18n.get('PAYONNER_STATUS_MESSAGES_APPROVED_TEXT')
      }
    };
  },

  renderPayoneerForm() {
    return (
      <div>
        <h5>{i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_LINK_PAYONEER')}</h5>
        <p className='text-justify'>
          {i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_PAYONNER_NEEDED')}
        </p>
        <p className='margin-top-1x'>
          {i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_RETURN_TO_VF',{companyName})}
        </p>

        <p className='margin-top-1x'>
          <a href={getCheckSwiftUrl()} target='_blank' data-uitest='find-your-swift-link'>
            {i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_FIND_SWIFT')}
          </a>
        </p>

        <div className='margin-top-1x'>
          <Button
            color='default'
            size='sm'
            onClick={this.payoneerRegister}
            data-uitest='go-to-payoneer'
          >
            {i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_GO_TO_PAYONEER')}
          </Button>
        </div>
      </div>
    );
  },

  getDescription() {
    const {currentUser} = this.props;
    const {payoneerStatus} = currentUser;
    const messagesPayoneer = this.getMessages();
    if (payoneerStatus) {
      const message = messagesPayoneer[payoneerStatus] || {};
      return i18n.get(
        'INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_BILLING_STATEMENT',
        {message: message.es}
      );
    }
    return (
      <div data-uitest='payoneer-status-message'>
        <p> {i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_NO_ACCOUNT')} </p>
        <p className='margin-top-1x'>
          {i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_WAIT_FOR_UPDATE')}
        </p>
      </div>
    );
  },

  render() {
    return (
      <div>
        <div className='vf-row'>
          <div className='col-xs-12'>
            <h4>{i18n.get('INF_SETTINGS_MONEY_DEPOSITS_PAYONEER_DEPOSIT')}</h4>
          </div>
        </div>

        <div className='vf-row padding-top-1x'>
          <div className='col-xs-12 col-sm-2'>
            <div className='vf-settings-money-logo'><img src={logoPayoneerImg} /></div>
          </div>
          <div className='col-xs-12 col-sm-10'>
            <div className='vf-row reverse-sm'>
              <div className='col-xs-12 col-sm-4'>
                <div className='vf-descriptor'>
                  <div>{this.getDescription()}</div>
                </div>
              </div>
              <div className='col-xs-12 padding-top-1x show-xs' />
              <div className='col-xs-12 col-sm-8'>
                {this.getContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

module.exports = PayoneerForm;
